import React from "react";
import { Helmet } from "react-helmet";

const SEOTag = ({ SEO_ENABLED, SEO_DESCRIPTION, SEO_TITLE, SEO_IMAGE }) => {
    return (
        <Helmet>
            {SEO_ENABLED && <meta fk-meta="true" name="robots" content="noindex" />}
            {SEO_TITLE && <title>{SEO_TITLE}</title>}
            {SEO_DESCRIPTION && <meta name="description" fk-meta="true" content={SEO_DESCRIPTION} />}

            {/* Open Graph */}
            {SEO_TITLE && <meta property="og:title" fk-meta="true" content={SEO_TITLE} />}
            {SEO_DESCRIPTION && <meta name="og:description" fk-meta="true" content={SEO_DESCRIPTION} />}
            {SEO_IMAGE && <meta property="og:image" fk-meta="true" content={SEO_IMAGE} />}

            {/* Twitter */}
            {SEO_TITLE && <meta name="twitter:title" fk-meta="true" content={SEO_TITLE} />}
            {SEO_DESCRIPTION && <meta name="twitter:description" fk-meta="true" content={SEO_DESCRIPTION} />}
            {SEO_IMAGE && <meta name="twitter:image" fk-meta="true" content={SEO_IMAGE} />}
        </Helmet>
    );
};

export default SEOTag;